/* src/app/shared/components/dropdown-select/dropdown-select.component.css */
:host ::ng-deep .p-dropdown {
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  background-color: #fff;
  transition: all 0.3s;
  box-shadow: none;
  width: 100% !important;
}
:host ::ng-deep .p-dropdown:hover {
  border-color: #40a9ff;
}
:host ::ng-deep .p-dropdown.p-focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}
:host ::ng-deep .p-dropdown .p-dropdown-label {
  font-size: 14px;
  padding: 5px 12px !important;
  min-height: 32px;
  border-right: none;
}
:host ::ng-deep .p-dropdown .p-dropdown-clear-icon {
  right: 2rem;
  color: #999;
}
:host ::ng-deep .p-dropdown .p-dropdown-trigger {
  color: rgba(0, 0, 0, 0.45);
  right: 0.75rem;
}
:host ::ng-deep .p-dropdown-panel {
  border-radius: 4px;
  box-shadow:
    0 3px 6px -4px rgba(0, 0, 0, 0.12),
    0 6px 16px 0 rgba(0, 0, 0, 0.08),
    0 9px 28px 8px rgba(0, 0, 0, 0.05);
}
:host ::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight.p-focus {
  background: #e6f7ff;
  color: #000;
  font-weight: 600;
}
:host ::ng-deep .p-dropdown-panel .p-dropdown-items {
  padding-left: 0px !important;
  margin-bottom: 0 !important;
}
:host ::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item {
  padding: 5px 12px !important;
}
:host ::ng-deep .p-dropdown-check-icon {
  display: none;
}
:host ::ng-deep blankicon {
  display: none !important;
}
:host ::ng-deep .p-dropdown.p-disabled {
  background: #f5f5f5;
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
:host ::ng-deep .p-dropdown.p-disabled .p-dropdown-label {
  background: #f5f5f5;
  color: rgba(0, 0, 0, 0.45);
  cursor: not-allowed;
}
:host ::ng-deep .p-dropdown-label.p-placeholder {
  color: #767676;
}
:host ::ng-deep .hide-arrow .p-dropdown-trigger {
  display: none !important;
}
:host ::ng-deep .hide-clear .p-dropdown-clear-icon {
  display: none !important;
}
.custom-dropdown-panel {
  width: auto !important;
  min-width: 100% !important;
  box-sizing: border-box;
}
::ng-deep .dropdown-scroll-limit .p-dropdown-items-wrapper {
  max-height: 130px !important;
  overflow-y: auto;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
/*# sourceMappingURL=dropdown-select.component-YLAN4AGM.css.map */
